import React, { useState, useEffect } from "react";
import CalendarView from "shared/CalendarView/CalendarView.shared";
import { DateHelper } from "shared/helpers/DateHelper";

export default function ItemCalendarView(props) {
  const {
    dateHelper,
    itemType,
    openItem,
    itemDay,
    setItemDay,
    activeDate,
    setActiveDate,
    calendarNotes,
    taskType,
    setTaskType,
  } = props;

  const [scrollOffset, setScrollOffset] = useState(
    dateHelper.heightOnCalendar(itemDay) - 100
  );
  const [isSomeday, setIsSomeday] = useState(false);

  useEffect(() => {
    if (isSomeday) {
      setItemDay(DateHelper.parseDate(openItem.details.day));
      setIsSomeday(false);
    }
    if (itemType === "appointment" && activeDate) {
      setActiveDate(null);
    }
  }, [itemType]);

  useEffect(() => {
    if (isSomeday && taskType === "critical") {
      setItemDay(DateHelper.parseDate(openItem.details.day));
      setIsSomeday(false);
    }
  }, [taskType]);

  useEffect(() => {
    if (isSomeday) {
      setTaskType("flexible");
    }
  }, [isSomeday]);

  function title() {
    switch (itemType) {
      case "calendar_note":
        return "Dates";
      case "task":
        return "Timeline";
      case "appointment":
        return "When";
      default:
        return "error";
    }
  }
  console.log("calendarNotes in location: ", calendarNotes);
  return (
    <div className={"Item-calendar-view " + itemType}>
      <span className="item-calendar-title">{title()}</span>
      <CalendarView
        calendarItems={calendarNotes}
        scrollOffset={scrollOffset}
        setScrollOffset={setScrollOffset}
        isSomeday={isSomeday}
        setIsSomeday={setIsSomeday}
        activeDate={activeDate}
        setActiveDate={setActiveDate}
        itemType={itemType}
        selectedDate={itemDay}
        setSelectedDate={setItemDay}
        dateHelper={dateHelper}
        offsetAboveSelectedDate={250}
        lastDay={dateHelper.getDateString()}
      />
    </div>
  );
}
